export default __webpack_public_path__ + "static/media/mw_title.06ce2a0d.gif";